import {AfterViewInit, Component, inject, OnDestroy} from '@angular/core';
import {
  PlayerProfileMessagesListComponent
} from './player-profile-messages-list/player-profile-messages-list.component';
import {Subscription} from 'rxjs';
import {ViewService} from '../../../../shared/service/view.service';
import {LayoutHelper} from '../../../../../helper/layout.helper';
import {PlayerSessionService} from '../../../service/player-session.service';

@Component({
  selector: 'app-player-profile-messages',
  imports: [
    PlayerProfileMessagesListComponent
  ],
  templateUrl: './player-profile-messages.component.html',
  styleUrl: './player-profile-messages.component.scss'
})
export class PlayerProfileMessagesComponent implements AfterViewInit, OnDestroy
{
  public view = inject(ViewService);
  private playerSessionService = inject(PlayerSessionService);

  positionTop: number;
  reload: boolean;
  viewSubscription: Subscription;
  menuHiddenChangeSubscription: Subscription;

  ngAfterViewInit(): void
  {
    this.viewSubscription = this.view.onSizeChanged.subscribe(() => this.onSizeChanged(false));
    setTimeout(() => this.onSizeChanged(false));

    this.menuHiddenChangeSubscription = this.playerSessionService.onMenuHiddenChanged.subscribe(
      () => setTimeout(() => this.onSizeChanged(true), 0));
  }
  ngOnDestroy(): void
  {
    this.viewSubscription?.unsubscribe();
    this.menuHiddenChangeSubscription?.unsubscribe();
  }

  public onSizeChanged(reloadView: boolean): void
  {
    const top = LayoutHelper.getTopFromElement('divMessages', this.view.isMobile ? 196 : 220);
    const footerHeight = document.getElementById('frontend_footer')?.offsetHeight;
    console.log('top: ' + top);
    this.positionTop = top + (this.view.isMobile ? 12 : 16) + (footerHeight ?? 40);
    console.log('positionTop: ' + this.positionTop);

    if (reloadView)
    {
      this.reload = true;
      setTimeout(() => this.reload = false);
    }
  }
}
